module.exports = __webpack_public_path__ + "static/media/Practice3.cd820ad1.bmp";